export const GET_STORED_FILTERS = 'getStoredFilters';
export const ITEM_BY_ID = 'itemById';
export const FILTER_PREFERENCES_ARE_APPLIED = 'filterPreferencesAreApplied';
export default {};
